import icons from "../../../../../Data/icons";
import classes from "./addCurrency.module.css";

const AddCurrency = ({
  setCurrencyName,
  setCurrencySymbol,
  setCurrencyRate,
  setCurrencyDefault,
  currencyName, currencySymbol, currencyRate ,currencyDefault
}) => {
  const DollarSign = icons.Dollar;

  const handleNameChange = (e) => {
    setCurrencyName(e.target.value);
  };
  const handleSymbolChange = (e) => {
    setCurrencySymbol(e.target.value);
  };
  const handleRateChange = (e) => {
    setCurrencyRate(e.target.value);
  };
  const handleDefaultChange = (e) => {
    const isChecked = e.target.checked
    setCurrencyDefault(isChecked ? 1 :0);
  };
  return (
    <div className={classes.formCard}>
    
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم العملة</label>
          <div className={classes.iconInput}>
            <DollarSign />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم العملة"
            onChange={handleNameChange}
            className={classes.inputCustom}
            value={currencyName}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">رمز العملة</label>
          <div className={classes.iconInput}>
            <DollarSign />
          </div>
          <input
            type="text"
            placeholder="ادخل رمز العملة"
            onChange={handleSymbolChange}
            className={classes.inputCustom}
            value={currencySymbol}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">المعدل</label>
          <div className={classes.iconInput}>
            <DollarSign />
          </div>
          <input
            type="text"
            placeholder="ادخل المعدل"
            onChange={handleRateChange}
            className={classes.inputCustom}
            value={currencyRate}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""  className={currencyDefault ? classes.Active : classes.disActive}>{currencyDefault === 1  ? " افتراضي" : " غير افتراضي"}</label>
       
          <label className="switch"> 
            <input
                  type="checkbox"  
                  checked={currencyDefault}
                   onChange={handleDefaultChange}
                  
                />
                <span className="slider round"></span>
            </label>
               
        </div>  
      </div>
    </div>
  );
};

export default AddCurrency;
